/** SA-1328: the words of the process list's passes (Task 1: headings and the revision entry). */

/** "2 Qualify the counterparty", or the title alone for a step with no number. */
export function stepHeading(number: number | null, title: string): string {
  return number === null ? title : `${number} ${title}`
}

export function reopenedHeading(heading: string): string {
  return `${heading} re-opened`
}

export const REVISED = 'Revised'

/** Why a revision happened, from the events beside it. */
export const REVISION_WHY = { customer_update: 'customer update applied', intake: 'intake edited' } as const

export const SHOW = 'Show'
export const HIDE = 'Hide'
export const NOW = 'Now'

/** A hinge's glyph: a re-open, a revision, a move back along an exit, a move back nothing explains. */
export const HINGE_GLYPH = { reopened: '↺', revised: '↻', sent_back: '⟲', went_back: '⟲' } as const

export function stepsWord(n: number): string {
  return `${n} ${n === 1 ? 'step' : 'steps'}`
}

export function earlierWord(n: number): string {
  return `${n} earlier ${n === 1 ? 'step' : 'steps'} in this pass`
}

/** "1 Enquiry arrives → 7 Feasibility result", one heading when first and last are the same entry. */
export function foldRange(first: { key: string; heading: string }, last: { key: string; heading: string }): string {
  return first.key === last.key ? first.heading : `${first.heading} → ${last.heading}`
}

export function foldButtonLabel(open: boolean, fold: { count: string; range: string }): string {
  return `${open ? HIDE : SHOW} ${fold.count}: ${fold.range}`
}

export function sentBackHeading(from: string, to: string): string {
  return `${from} sent back to ${to}`
}

export function wentBackHeading(to: string): string {
  return `Went back to ${to}`
}
